// extracted by mini-css-extract-plugin
module.exports = {"info":"_f77d492"};